module.exports = "/images/oruc.png?00e0548ed0e07fbe64199d4b66cc8ef6";